(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gd-best-of-dallas-vote"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.__gdBestOfDallasVoteTracking)return;
  window.__gdBestOfDallasVoteTracking=true;
  document.addEventListener('click',function(event){
    var target=event.target;
    if(!target||!target.closest)return;
    var link=target.closest('[data-gd-intent="vote"]');
    if(!link)return;
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({
      event:'gd_vote_intent',
      campaign:link.dataset.gdCampaign||'best-of-dallas-2026',
      placement:link.dataset.gdPlacement||'unknown',
      link_url:link.href,
      link_text:(link.textContent||'').trim(),
      page_path:window.location.pathname
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
